import { z } from 'zod';

import { requiredString } from '@/shared/utils/validation';

export const companyOnboardingSchema = z.object({
  companyName: requiredString(),
  country: z.string(),
  industry: z.string(),
});
